export const getRandomNumber = (maxNumber: number) =>
  Math.floor(Math.random() * maxNumber);
